import styled, { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  :root {
    --white: #ffffff;
    --white-100: #f3f3f3;
    --white-200: #fafcff;
    --white-300: #e2e3e4;
    --white-400: #cbd2e0;

    --gold: #efda9f;
    --gold-100: #d0b877;
    --gold-200: #ac924d;
    --gold-300: #635530;

    --blue: #1a325f;
    --blue-900: #020a19;

    --purple: #8789b9;
    --purple-100: #5e3ea1;
    --purple-200: #4c357d;
    --purple-300: #2f224a;
    --purple-100-rgba: rgba(94, 62, 161, 0.1);
    --purple-300-rgba: rgb(46, 34, 74, 0.7);

    --red: #fe3a02;
    --red-400: #633030;

    --green: #faffde;
    --green-100: #bde100;
    --green-200: #99d939;
    --green-300: #5a9418;
    --green-400: #063b17;

    --pink: #e7426b;
    --pink-100: #e58297;
    --pink-100-rgba: rgba(227, 0, 113, 0.4);


    --black: #111111;
    --black-rgba: rgba(0, 0, 0, .3);
    --black-100-rgba: rgba(255, 255, 255, 0);
    --black-200-rgba: rgba(17, 17, 17, 1);
    --black-rgba-300: rgba(0, 0, 0, .9);

    --roboto: 'Roboto';
    --montserrat: 'Montserrat';
    --rumraisin: 'Rum Raisin';
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    @media (max-width: 1280px) {
      font-size: 93.75%
    }

    @media (max-width: 720px) {
      font-size: 87.5%
    }

    @media (max-width: 480px) {
      font-size: 77.5%
    }
  }

  body {
    color: var(--black);
    background: var(--white);
    -webkit-font-smoothing: antialiased;
  }

  body {
    background-color: var(--purple-300);
  }

  body, input, textarea, button {
    font-family: 'Lato', sans-serif;
    font-weight: 400;
  }

  h1, h2, h3, h3, h4, h5, h6, strong {
    font-weight: 700;
  }

  a {
    outline: none;
    color: inherit;
    text-decoration: none;
    transition: ease-in .2s;

    &:hover {
      transition: ease-out .3s;
    }
  }

  button {
    cursor: pointer;
  }

  [disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .react-modal-overlay {
    backdrop-filter: blur(10px) hue-rotate(80deg);
    background: var(--black-rgba);
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
  }

  .react-modal-content {
    border: 2px solid var(--gold-200);
    background: linear-gradient(190deg, var(--purple-300) 0%, var(--black) 100%);
    overflow: auto;
    border-radius: 4px;
    position: relative;
    width: 100%;
    max-width: 520px;
    min-height: 280px;
    padding: 30px 20px;

    @media (max-width: 480px) {
      width: 98%;
      //height: 80vh;
      padding: 30px 20px;
    }
  }

  .react-modal-close {
    position: absolute;
    right: 1rem;
    top: .5rem;
    border: 0;
    background: transparent;
    font-size: 2rem;
    color: var(--gold-100);
    transition: ease-in .2s;

    &:hover {
      transition: ease-out .4s;
      color: var(--blue-900);
    }
  }

  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background-color: var(--purple-200);
  }

  ::-webkit-scrollbar-thumb {
    background-color: var(--purple);
    border-radius: 5px;

    :hover {
      background-color: var(--pink);
    }
  }
`

const Container = styled.div`
  background-color: var(--background);
  height: 100vh;
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: auto;
`

export { GlobalStyle, Container }
